import { Rescatable } from '../Rescatable';
import { SubcategoryGrouper } from './SubcategoryGrouper';
import { Product } from './Product';
import { SubcategoryBanner } from './SubcategoryBanner';

export class Subcategory extends Rescatable {
  static _name = 'Subcategory';
  static pathRequest = Rescatable.pathRequestStatic + 'categorias_sub';
  static pk: keyof Subcategory = 'id';
  static indexes: (keyof Subcategory)[] = ['id'];
  id: number;
  nombre: string;
  id_agrupador: number;
  sub_cate_oculto_ponderado: string;
  imagen: string;
  $bannersSubcategorias: SubcategoryBanner[];
  $subcategoryGrouper?: SubcategoryGrouper;
  $products?: Product[];
  orden: number | null;
  constructor(e: Subcategory) {
    super(e);
  }
}
